import { render } from "./LoginMenuView.vue?vue&type=template&id=736175fd&scoped=true"
import script from "./LoginMenuView.vue?vue&type=script&lang=js"
export * from "./LoginMenuView.vue?vue&type=script&lang=js"

import "./LoginMenuView.vue?vue&type=style&index=0&id=736175fd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-736175fd"]])

export default __exports__